import { EnumTransferDirection, FilterOperatorTypes } from '../../graphql/types';
import { ROUTES } from '../../routes';

export interface TransferGroupHashFilter {
  key: 'hash';
  operator: FilterOperatorTypes;
  value: string;
}

export function buildTransferGroupFilterUrl(filterQuery: object) {
  return `${ROUTES.allTransfers}?filterQuery=${encodeURIComponent(JSON.stringify(filterQuery))}`;
}

export function buildTransferGroupCurrencyFilterUrlParam(
  currency: string,
  direction?: EnumTransferDirection | null,
) {
  return buildTransferGroupFilterUrl({
    currency: [
      {
        currency,
        operator: FilterOperatorTypes.Is,
        ...(direction ? { direction } : {}),
      },
    ],
  });
}

export function buildTransferGroupHashFilterObject(hash: string): TransferGroupHashFilter {
  return {
    key: 'hash',
    operator: FilterOperatorTypes.Is,
    value: hash,
  };
}

export function buildTransferGroupHashFilterUrlParam(hashes: string[]) {
  return buildTransferGroupFilterUrl({
    hash: hashes.map(buildTransferGroupHashFilterObject),
  });
}

export function buildTransferGroupContractAddressFilterUrlParam(contractAddress: string) {
  return buildTransferGroupFilterUrl({
    contractAddress: [
      {
        key: 'contractAddress',
        operator: FilterOperatorTypes.Is,
        value: contractAddress,
      },
    ],
  });
}

export function buildTransferGroupMethodIdFilterUrlParam(methodId: string) {
  return buildTransferGroupFilterUrl({
    methodId: [
      {
        key: 'methodId',
        operator: FilterOperatorTypes.Is,
        value: methodId,
      },
    ],
  });
}

export function buildTransferGroupTransferAddressFilterUrlParam(
  transferAddress: string,
  direction?: EnumTransferDirection | null,
) {
  return buildTransferGroupFilterUrl({
    transferAddress: [
      {
        operator: FilterOperatorTypes.Is,
        value: transferAddress,
        ...(direction ? { direction } : {}),
      },
    ],
  });
}

export function buildTransferGroupImportsFilterUrlParam(credentialIds: number[]) {
  return buildTransferGroupFilterUrl({
    imports: {
      operator: FilterOperatorTypes.Is,
      values: credentialIds,
    },
  });
}

export function buildTransferGroupDateAndCurrencyFilterUrlParam(date: string, currency?: string) {
  return buildTransferGroupFilterUrl({
    date: {
      fromDate: date,
      toDate: date,
    },
    ...(currency
      ? {
          currency: [
            {
              currency,
              operator: FilterOperatorTypes.Is,
            },
          ],
        }
      : {}),
  });
}
